/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/offcanvas';
import './components/delay-search-queries';
import './components/video';
import './components/footer-menus';
import './components/scroll-to-top';
import './components/foundation.app';
import './components/accessibility';
import './components/lazy.jquery';
import './components/copy-link';
import './components/wp-gallery-swiper';
import './components/vacancies';
import './components/sticky-header-scroll';

function updateSubmenuLayouts() {
	const nav = document.querySelector('nav#menu');
	if (!nav) return;

	const navRect = nav.getBoundingClientRect();
	const navWidth = navRect.width;

	if (window.innerWidth >= 1024) {
		document.querySelectorAll('li.multicolumn-submenu').forEach(li => {
			const liRect = li.getBoundingClientRect();
			const submenu = li.querySelector(':scope > .submenu');

			if (submenu) {
				submenu.style.width = navWidth + 'px';

				const offsetLeft = navRect.left - liRect.left;
				submenu.style.left = offsetLeft + 'px';
			}
		});
	} else {
		document.querySelectorAll('li.multicolumn-submenu .submenu').forEach(submenu => {
			submenu.style.width = '';
			submenu.style.left = '';
		});
	}
}

document.addEventListener('DOMContentLoaded', updateSubmenuLayouts);
window.addEventListener('resize', updateSubmenuLayouts);
